import client from '../../../client-unauthenticated';
import CultureCodeEnum from '../../../../../models/culture-code-enum';
import { BasketType } from '../../../../../models/basket-type';

export default async function updateLineItems(
  catalogId: string,
  session: string,
  basketId: string,
  lineItems: { orderLineId: number; newQuantity: number }[]
): Promise<BasketType> {
  const { data } = await client.post<BasketType>(
    '/basket/guest/update-line-items',
    {
      cultureCode: CultureCodeEnum.EnGb,
      domain: process.env.NEXT_PUBLIC_DOMAIN,
      provider: 0,
      catalogId,
      session,
      basketId,
      lineItems,
    }
  );

  return data;
}
